import {Component} from '@angular/core';
import {AppService} from "@core/services/app.service";
import {AuthService} from "@core/authentication/auth.service";


@Component({
  standalone: false,
  selector: 'app-error-404',
  template: `
    <div class="matero-error-wrap pt-lg-3">
      <div class="matero-error-title mb-3">404 - Page not found</div>
      <div class="matero-error-message">Trang không tồn tại hoặc dữ liệu không hợp lệ</div>
      <div>
        <!-- Nút quay lại: Tự động điều hướng về trang chủ của module hiện tại (Ads hoặc Vpage) -->
        <a class="btn btn-primary px-4" [routerLink]="app.getDefaultRedirectUrl()">
          {{ 'common.backHome' | transloco }}
        </a>
      </div>
    </div>
  `,
  styles: [`
    .matero-error-wrap {
      text-align: center;
      position: relative;
      display: flex;
      flex-flow: column;
      height: 60vh;
      justify-content: center;
    }

    .matero-error-title {
      margin: 0 0 16px;
      font-size: 32px;
      font-weight: 500;
      line-height: 32px;
    }

    .matero-error-message {
      margin: 0 0 16px;
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
    }

  `],
})
export class Error404Component {

  constructor(
    public app: AppService,
    private authService: AuthService
  ) {
  }
}
